<template>
  <div>
    <vs-icon
      icon="history"
      size="small"
      @click="checkHistory"
    />
    <b-modal
      v-if="showModal"
      v-model="showModal"
      title="Versiones anteriores"
      size="lg"
      centered
      no-close-on-backdrop
      hide-footer
    >
      <div class="w-100 text-center">
        <b-spinner
          v-if="loading"
          variant="primary"
        />
      </div>
      <h5
        class="text-center"
        v-if="previousVersions.length === 0 && !loading"
      >
        No hay versiones anteriores
      </h5>
      <table v-if="!loading && previousVersions.length > 0" class="w-100 text-center">
        <thead>
          <tr>
            <th>
              Archivo
            </th>
            <th>
              Fecha
            </th>
            <th>
              Versi&oacute;n externa
            </th>
            <th>
              Tama&ntilde;o
            </th>
            <th>
              Descargar
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="version in previousVersions" :key="version.versionId">
            <td>
              <span :title="`${version.nombre}`">
                {{version.nombre | truncate(30)}}
              </span>
            </td>
            <td>
              {{version.fechaModificado | dateCompleteFormat}}
            </td>
            <td>
              {{version.versionExterna}}
            </td>
            <td>
              {{version.peso | formatSize}}
            </td>
            <td class="d-flex align-items-center justify-content-center">
              <vs-icon
                icon="file_download"
                class="cursor-pointer"
                size="small"
                v-tooltip="'Descargar versión anterior'"
                @click="downloadFile(version.urlDescarga)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PreviousVersions',
  props: ['element'],
  data() {
    return {
      loading: true,
      showModal: false
    };
  },
  computed: {
    ...mapGetters('DocManagement', ['previousVersions'])
  },
  methods: {
    ...mapActions('DocManagement', ['getPreviousVersion']),
    async checkHistory() {
      this.showModal = true;
      await this.getPreviousVersion(this.element);
      this.loading = false;
    },
    downloadFile(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped>

</style>
